import { m } from '@aimfora/i18n'
import { createFileRoute } from '@tanstack/react-router'
import { SubmissionsPage } from '~/components/submissions/submissions-page'
import { getExamSubmissions } from '~/functions/submissions.functions'
import { examKeys, scopeOf } from '~/lib/query-keys'

// The trailing underscore keeps this page out of the exam page's layout: it is a page of its own
export const Route = createFileRoute('/_authed/app/exams/$examId_/submissions')({
  head: () => ({ meta: [{ title: `${m.submissions_title()} - ${m.app_name()}` }] }),
  // A missing exam, and one the caller may not see, both end in the "not found" page
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData({
      queryKey: examKeys.submissions(scopeOf(context.session), params.examId),
      queryFn: () => getExamSubmissions({ data: { examId: params.examId } }),
    }),
  component: SubmissionsRoute,
})

function SubmissionsRoute() {
  const { examId } = Route.useParams()
  return <SubmissionsPage examId={examId} />
}
